var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgShark = function SvgShark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    fillRule: "evenodd",
    d: "M63.375 80.063c5.952 2.285 14.644 8.206 19.606 11.761l-1.973-7.773a1.266 1.266 0 0 1 .515-1.437l5.778-3.788c-3.43-2.58-6.228-4.54-10.071-6.563zM36.525 80.032c-5.952 2.286-14.644 8.207-19.605 11.762l1.972-7.773a1.266 1.266 0 0 0-.514-1.437l-5.779-3.788c3.431-2.58 6.228-4.541 10.072-6.563z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M84.453 61.284V31.985a9.04 9.04 0 0 0-4.52-7.828L54.559 9.507a9.04 9.04 0 0 0-9.04 0l-25.374 14.65a9.04 9.04 0 0 0-4.52 7.828v29.3a9.04 9.04 0 0 0 4.52 7.828l25.374 14.65a9.04 9.04 0 0 0 9.04 0l25.374-14.65a9.04 9.04 0 0 0 4.52-7.829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M82.528 60.466V32.804a8.54 8.54 0 0 0-4.268-7.391l-23.955-13.83a8.53 8.53 0 0 0-8.535 0l-23.955 13.83a8.54 8.54 0 0 0-4.268 7.391v27.661a8.53 8.53 0 0 0 4.268 7.392l23.955 13.83a8.53 8.53 0 0 0 8.535 0l23.955-13.83a8.54 8.54 0 0 0 4.267-7.392"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M78.995 58.962V34.308a7.61 7.61 0 0 0-3.804-6.588l-21.35-12.326a7.6 7.6 0 0 0-7.606 0L24.885 27.72a7.61 7.61 0 0 0-3.804 6.588v24.654a7.61 7.61 0 0 0 3.804 6.587l21.35 12.326a7.6 7.6 0 0 0 7.606 0l21.35-12.326a7.61 7.61 0 0 0 3.804-6.587"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "shark_svg__a",
    width: 34,
    height: 38,
    x: 32,
    y: 29,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.919 29.627H32.67v36.457H65.92z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M34.681 42.488q.016.03.039.055zm25.023-7.02c.312-1.353 2.318-3.369 2.626-5.011-2.693-1.834-7.643-.394-9.62 2.012-7.095-.51-13.368-.39-19.715 1.481-.816 3.098-.028 6.048 1.674 8.52-.47-.745-.193-1.256.532-1.603.88-.42 2.423-.599 4.111-.656q.56-.026 1.16-.026.378-.002.77.007h.01l.098.001.076.003h.065q.034 0 .066.003l.04.002c1.157.03 2.378.117 3.597.25l.065.007c4.785.635 6.357.936 10.298 3.539a16 16 0 0 1 2.96 2.531l.013.016q0 .011.01.022a.1.1 0 0 0 .034.038l-.008-.012q-.005-.004-.005-.008l-.012-.019q.269.31.502.633.06.081.114.161c1.946 2.815 1.806 6.15.447 8.94q-.029.062-.06.121a11.241 11.241 0 0 1-1.164 1.838q-.031.044-.067.088a10.9 10.9 0 0 1-2.43 2.255q-.098.065-.196.127l-.143.089a7 7 0 0 1-.286.17l-.055.032q-.038.02-.076.04-.052.03-.104.056-.052.03-.105.055a8.7 8.7 0 0 1-2.577.872c12.155-1.32 19.483-15.839 7.357-26.577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.007,
    d: "M39.457 36.304a1.583 1.583 0 1 0 1.581-1.583c-.873 0-1.58.71-1.58 1.583Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M58.547 46.567q-.008-.016-.016-.024l-.001.005q-.002.013.02.024l.024.032q-.014-.022-.027-.037M50.89 62.138c.477.023.966-.011 1.455-.095q-.718.08-1.455.095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M58.54 46.565a.1.1 0 0 0 .034.038l-.01-.013q-.012-.012-.024-.025m-3.277 14.423a10.5 10.5 0 0 0 3.057-2.643 10.7 10.7 0 0 1-3.057 2.643"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M59.611 56.3q-.03.062-.06.12a11 11 0 0 1-1.161 1.838l-.07.087a10.8 10.8 0 0 1-2.626 2.384l-.143.092c-1.389.84-2.979 1.333-4.661 1.318-.664 1.653-4.538 5.039-7.528 3.598a.4.4 0 0 1-.218-.428c.312-1.928 3.088-6.087 3.088-6.301 0 0-1.268-4.054-1.555-5.239a.614.614 0 0 1 .4-.735c2.3-.07 4.443 1.941 5.137 3.988.563.006 4.89-.322 4.906-2.486.3-2.114-.784-3.59-2.471-4.385-5.84-2.03-10.797 1.797-17.978-7.68-.395-.74-.131-1.253.533-1.604.88-.42 2.422-.599 4.11-.656q.56-.026 1.16-.026c1.948.023 3.85.188 4.786.272 4.785.635 6.357.935 10.299 3.537a16 16 0 0 1 2.962 2.532l.011.016q0 .01.01.021a.1.1 0 0 0 .034.039l-.025-.038q.269.31.503.633l.113.161c1.908 2.774 1.8 6.129.448 8.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M40.471 40.184q-.598 0-1.159.025c-1.688.058-3.23.235-4.11.656 1.073-.566 3.198-.705 5.268-.68zM59.551 56.422a7 7 0 0 1-.119.229q.062-.115.12-.23M55.889 60.6a10.9 10.9 0 0 0 2.43-2.255l.07-.087.066-.088q.55-.721.977-1.52a10.8 10.8 0 0 1-3.543 3.95M58.574 46.603q-.014-.016-.024-.033-.022-.01-.02-.022l.001-.004.017.023z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shark_svg__b",
    width: 59,
    height: 65,
    x: 20,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.756 58.97V34.31a7.61 7.61 0 0 0-3.805-6.588L53.596 15.393a7.61 7.61 0 0 0-7.608 0l-21.355 12.33a7.61 7.61 0 0 0-3.804 6.59V58.97a7.61 7.61 0 0 0 3.805 6.589l21.355 12.328a7.61 7.61 0 0 0 7.608 0l21.356-12.33a7.61 7.61 0 0 0 3.803-6.588"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#shark_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.867-12.167-66.37 51.39 13.25 17.11L70.115 4.946zM71.79 8.624 5.42 60.013 8.77 64.34l66.37-51.389z"
  })))));
};
export default SvgShark;